import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import {
  STORE_CHANNEL_UPDATE_LOADING,
  SERVICE_FAILURE,
  STORE_CHANNEL_FIND_ALL_CONFIGURATION,
  STORE_CHANNEL_FIND_ALL_CONFIGURATION_SUCCESS,
} from '@store/actions';
import { LocalCanalConfiguracion } from '@core/models';
import { StoreChannelConfigurationService } from '@core/services';

@Injectable()
export class StoreChannelConfigurationEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private storeChannelConfigurationService: StoreChannelConfigurationService
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STORE_CHANNEL_FIND_ALL_CONFIGURATION),
      mergeMap((storeChannelFilter) => {
        this.store.dispatch(STORE_CHANNEL_UPDATE_LOADING({  loading: true }));

        return this.storeChannelConfigurationService.findAll(storeChannelFilter).pipe(
          mergeMap(({ data }) => {
            const storeChannelConfigurationList = data as LocalCanalConfiguracion[];

            return [
              STORE_CHANNEL_FIND_ALL_CONFIGURATION_SUCCESS({ storeChannelConfigurationList }),
              STORE_CHANNEL_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => 
            of(error).pipe(
              mergeMap((error) => {
                return [
                  SERVICE_FAILURE({ error }),
                  STORE_CHANNEL_UPDATE_LOADING({ loading: false }),
                ];
              })
            )
          )
        )
      }),
    )
  );
}
